import axios from 'axios';
import { provide } from '@hilma/tools';
import { FormProvider, FormInput, FormCheckBox, useForm, useAlert } from '@hilma/netina2all';

import { associationRules } from '../constants';
import { Button } from '../components';
import { useI18n } from '../hooks';

const initialValues = {
	associationName: '',
	contactName: '',
	phone: '',
	confirmPhone: '',
	email: '',
	website: '',
	haveSection46: false,
	haveSignedContract: false,
	haveDrivers: false
};

const refs = { associationName: null, contactName: null, phone: null, email: null };

interface AssociationRegistrationFormProps {
	openPopup(): void;
}

const AssociationRegistrationForm: React.FC<AssociationRegistrationFormProps> = ({ openPopup }) => {
	const assoReg = useI18n(i18n => i18n.assoReg);
	const errText = useI18n(i18n => i18n.errText);
	const url = useI18n(i18n => i18n.am.url);
	const pd = useI18n(i18n => i18n.pd);

	const form = useForm();
	const alert = useAlert();

	const onSubmit = async () => {
		try {
			form.handleSubmit();
			if (!form.isValid || !Object.values(form.touched).length) return;
			await axios.post('/api/association/add-association', { association: form.values });
			openPopup();
		} catch (err: any) {
			console.error(err);
			alert(err.status === 409 ? err.data.message === "association name already exists" ? errText.associationNameExists : errText.associationExists : errText.generalShort);
		}
	}

	return (
		<form className="form">
			<FormInput id="associationName" description={assoReg.form.assoName} />
			<FormInput id="contactName" description={assoReg.form.conName} />
			<FormInput id="phone" dir="ltr" description={assoReg.form.phone} />
			<FormInput id="confirmPhone" dir="ltr" description={pd.confirmPhone} />
			<FormInput id="email" type="email" dir="ltr" description={assoReg.form.email} />
			<FormInput id="website" dir="ltr" description={url} />
			<FormCheckBox id="haveSection46" description={assoReg.form.has46} />
			<FormCheckBox id="haveSignedContract" description={assoReg.form.hasReport} />
			<FormCheckBox id="haveDrivers" description={assoReg.form.responsibility} />
			<Button submit onClick={onSubmit}>{assoReg.sendBtn}</Button>
		</form>
	);
}

export default provide(
	[FormProvider, { initialValues, refs, rules: associationRules }]
)(AssociationRegistrationForm);